// useMonthlyBilling stub - Simplified billing

import { useMutation, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useMonthlyBilling() {
  return {
    data: null,
    isLoading: false,
    generateInvoices: useMutation({
      mutationFn: async (_companyIds: string[]) => ({ success: false })
    }),
    isGenerating: false
  };
}

export function useDefaultTemplate() {
  const { data: defaultTemplate, isLoading } = useQuery({
    queryKey: ['default-invoice-template'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('billing_settings')
        .select('setting_value')
        .eq('setting_key', 'default_invoice_template')
        .single();
      
      if (error || !data) return 'azure-modern';
      return (data.setting_value as any)?.template_id || 'azure-modern';
    }
  });

  const setDefaultTemplate = useMutation({
    mutationFn: async (templateId: string) => {
      const { error } = await supabase
        .from('billing_settings')
        .upsert({
          setting_key: 'default_invoice_template',
          setting_value: { template_id: templateId },
          updated_at: new Date().toISOString()
        }, { onConflict: 'setting_key' });
      
      if (error) throw error;
      return { success: true };
    }
  });

  return {
    defaultTemplate: defaultTemplate || 'azure-modern',
    isLoading,
    setDefaultTemplate: (templateId: string) => setDefaultTemplate.mutateAsync(templateId),
    isUpdating: setDefaultTemplate.isPending
  };
}

export default useMonthlyBilling;
